import { render, staticRenderFns } from "./ProjectFinish.vue?vue&type=template&id=1062f916&"
import script from "./ProjectFinish.vue?vue&type=script&lang=ts&"
export * from "./ProjectFinish.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports